import React from "react";
import styled from "styled-components";


export type CustomFormFieldFooterProps = {
    text: string;
    
}

export function CustomFormFieldFooter(props: CustomFormFieldFooterProps): JSX.Element {
    
    
    return (
        <>
            <CustomFormFieldFooterStyle dangerouslySetInnerHTML={{ __html: props.text || '' }} />
        </>
    );
}


const CustomFormFieldFooterStyle = styled.div`
    /* box-shadow: inset 0 7px 9px -7px rgba(0,0,0,0.4); */
    box-shadow: inset 0 9px 9px -5px rgba(0,0,0,0.5);
    background-color: ${props => props.theme.colors.card.attention.default.background};
    padding: 1rem;
`